import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/settings/jobtypes/$id/edit')({
  component: () => null,
});
